import React, { isValidElement } from "react";
import { XCloseIcon } from "@assets/icons";
import {
    StyledCloseIconContainer,
    StyledSideDrawer,
    StyledTitle,
} from "./sideDrawer.styles";
import { SideDrawerProps } from "./sideDrawer.types";

// You can export Drawer directly
export const SideDrawer: React.FC<SideDrawerProps> = ({
    onClose,
    title,
    closeIcon = true,
    ...props
}) => {
    const customTitle = (
        <StyledTitle>
            {title}
            {closeIcon && (
                <StyledCloseIconContainer onClick={onClose}>
                    {isValidElement(closeIcon) ? closeIcon : <XCloseIcon />}
                </StyledCloseIconContainer>
            )}
        </StyledTitle>
    );
    return (
        <StyledSideDrawer
            {...props}
            title={customTitle}
            closable={false}
            onClose={onClose}
        >
            {props.children}
        </StyledSideDrawer>
    );
};
